import {ProductNameResponseItemDTO, ProductResponseDTO} from "@shared/DTO";
import {ProductTypeEnum} from "@shared/enums";
import {AbSelectOption} from "@/scripts/components/ab-select/ab-select.types";

interface BuildCompareBoxOptionsParams {
  allProducts: ProductNameResponseItemDTO[];
  currentProducts: ProductResponseDTO[];
}

export function resolveComparableProductTypes(sampleType?: ProductTypeEnum): ProductTypeEnum[] {
  if (!sampleType) return [];
  if(sampleType === ProductTypeEnum.OBIETTIVO) return [ProductTypeEnum.OBIETTIVO];
  if ([ProductTypeEnum.BRIDGE, ProductTypeEnum.COMPATTA].includes(sampleType)) {
    return [ProductTypeEnum.BRIDGE, ProductTypeEnum.COMPATTA];
  }
  if ([ProductTypeEnum.REFLEX, ProductTypeEnum.MIRRORLESS].includes(sampleType)) {
    return [ProductTypeEnum.REFLEX, ProductTypeEnum.MIRRORLESS];
  }
  return [];
}

export function buildCompareBoxOptions({
  allProducts,
  currentProducts,
}: BuildCompareBoxOptionsParams): AbSelectOption[] {

  if (!allProducts?.length) {
    return [];
  }
  const currentIds = new Set((currentProducts ?? []).map(product => product?._id).filter(Boolean));

  return allProducts
    .filter(product => {
      const productId = product?._id;
      if (!productId || currentIds.has(productId)) {
        return false;
      }
      return Boolean(product.productData?.names?.length);
    })
    .map( product => {
      const productType = product?.productData?.productType;
      // TODO parte weak: evitare queste label hardcodate
      const productTypeName = productType === ProductTypeEnum.OBIETTIVO ?
        'Obiettivi' :
        'Fotocamere';
      return {
        label: product.productData.names[0],
        id: product._id,
        group: `${productTypeName} ${product.productData.brand}`
      }
    });
}
